export const TERMINAL_PAYMENT_STATUSES = ["PAID", "FAILED", "EXPIRED", "CANCELLED", "REJECTED"];

export const paymentStatusLabel = (status) => ({
  PENDING: "Menunggu pembayaran",
  SUBMITTING: "Menyiapkan pembayaran",
  CREDITING: "Pembayaran berhasil, menambahkan kredit",
  RECONCILING: "Status pembayaran sedang diperiksa",
  WAITING_VERIFICATION: "Menunggu verifikasi Admin",
  PAID: "Pembayaran berhasil",
  FAILED: "Pembayaran gagal",
  EXPIRED: "Pembayaran kedaluwarsa",
  CANCELLED: "Pembayaran dibatalkan",
  REJECTED: "Pembayaran ditolak",
})[status] || "Status pembayaran sedang diperiksa";

export const isPaymentPending = (order) => Boolean(order) && !TERMINAL_PAYMENT_STATUSES.includes(order.status);

// An old QR can remain on a terminal or uncertain gateway response. Only an
// explicitly pending order should continue offering a way to pay it.
export const canPayQris = (order) => order?.status === "PENDING";
